module.exports = __webpack_public_path__ + "img/slider_galery_8.b252b8cf.jpg";